export default __webpack_public_path__ + "static/media/categories.e0ebe8c5.svg";